import { List } from '@tink/core/src/components/atoms/List/List';
import { styled } from '../../../../../../../core/theme/styled';

export const StepNumber = styled.div`
  font-weight: ${(props) => props.theme.font.weights.semiBold};
  font-size: ${(props) => props.theme.sizes.small};
  color: ${(props) => props.theme.configuration.primaryTextColor};
`;

export const Steps = styled(List)`
  border-radius: ${(props) => props.theme.sizes.small};
  padding: ${(props) => props.theme.sizes.normal};
  background-color: ${(props) => props.theme.configuration.tintedBackgroundColor};
  margin: ${(props) => props.theme.sizes.small} 0;
`;

export const StyledImage = styled.img`
  height: 48px;
`;

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${(props) => props.theme.sizes.normedium} 0;
`;

export const StyledUserHintId = styled.div`
  color: ${(props) => props.theme.configuration.secondaryTextColor};
  margin-bottom: ${(props) => props.theme.sizes.small};
  font-size: ${(props) => props.theme.sizes.small};
  text-align: center;
`;
